/* unplugin-vue-components disabled */import script from "./ConfirmRegistration.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmRegistration.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmRegistration.vue?vue&type=style&index=0&id=51bf0bf3&lang=scss"

const __exports__ = script;

export default __exports__